import { t } from '@lingui/macro';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { IP_RULE_FIELD } from '../../ip-form/IpFormConstants';
import {
    AGENT_DESCRIPTION_FIELD,
    AGENT_MODEL_SHORT_DISPLAY_FIELD,
    AGENT_NAME_FIELD,
    AGENT_NETWORK_IPV4_EXTERNAL_FIELD,
    AGENT_NETWORK_IPV4_LOCAL_FIELD,
    AGENT_NETWORK_MAC_FIELD,
    AGENT_SERIAL_NUMBER,
    AGENT_STATUS_FIELD,
    AGENT_TAGS_DISPLAY_FIELD,
} from '../agents/AgentConstants';
import { SORT_ASC } from '../../../utilities/FormUtilities';

export const MAX_AUTO_INTERFACES = 50;
export const SITE_IMPORT_FILE_FIELD = 'siteImportFile';
export const SITE_IMPORT_ERROR_LOG_FIELD = 'errorLog';
export const SITE_IMPORT_STATUSES = {
    FAILED: 'failed',
    PARTIAL_SUCCESS: 'partialSuccess',
    PROCESSING: 'processing',
    SUCCESS: 'success',
};

export const SITE_IMPORT_STATUS_MAP = {
    [SITE_IMPORT_STATUSES.PARTIAL_SUCCESS]: t`Partial Success`,
    [SITE_IMPORT_STATUSES.SUCCESS]: t`Success`,
    [SITE_IMPORT_STATUSES.FAILED]: t`Failed`,
};

export const NAME_FIELD = 'name';
export const NORM_NAME_FIELD = 'norm_name';
export const DESCRIPTION_FIELD = 'description';
export const LATITUDE_FIELD = 'latitude';
export const LONGITUDE_FIELD = 'longitude';
export const COUNTRY_FIELD = 'country';
export const PROVINCE_FIELD = 'province';
export const CITY_FIELD = 'city';
export const NOTES_FIELD = 'notes';
export const MATCHING_AGENTS_FIELD = 'matchingAgents';
export const MATCHING_AGENTS_SORTABLE_FIELD = 'matchingAgentsSortable';
export const TAGS_FIELD = 'tags';
export const IN_SPEED_FIELD = 'inSpeed';
export const OUT_SPEED_FIELD = 'outSpeed';
export const IP_RULES_FIELD = 'rules';
export const AGENTS_FIELD = 'agents';
export const WAN_INTERFACES_FIELD = 'wanInterfaces';
export const NOTIFICATIONS_EMAIL_FIELD = 'email';
export const WAN_META_FIELD = 'wanInterfacesAddition';
export const WAN_META_DELETES_FIELD = 'manualDeleteIds';
export const WAN_META_ADDS_FIELD = 'manualAddIds';

export const DEVICE_COUNT_FIELD = 'deviceCount';
export const AGENT_COUNT_FIELD = 'agentCount';
export const DEVICE_TYPE_FIELD = 'deviceType';
export const IP_ADDRESS_FIELD = 'ipAddress';
export const NORM_IP_ADDRESS_FIELD = 'norm_ipAddress';
export const RULE_VALUE_DISPLAY_FIELD = 'rule.valueDisplay';

export const WAN_DEVICE_MANUAL_FIELD = 'manual';
export const WAN_NAME_FIELD = 'name';
export const WAN_DEVICE_NAME_FIELD = 'deviceName';
export const WAN_DEVICE_IP_ADDRESS_FIELD = 'deviceIpAddress';
export const WAN_DEVICE_NORM_IP_ADDRESS_FIELD = 'norm_deviceIpAddress';
export const WAN_DEVICE_IF_TYPE_FIELD = 'ifType';
export const WAN_DEVICE_DESCRIPTION_FIELD = 'description';
export const WAN_DEVICE_DUPLEX_FIELD = 'duplex';

export const RULES_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        title: t`IP Scope`,
        sortable: true,
        mapping: IP_RULE_FIELD,
        width: 250,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Description`,
        sortable: true,
        mapping: DESCRIPTION_FIELD,
        width: 250,
    },
    {
        type: COLUMN_TYPES.NUMERIC,
        title: t`Monitored Device Count`,
        sortable: true,
        mapping: DEVICE_COUNT_FIELD,
        width: 210,
    },
    {
        type: COLUMN_TYPES.NUMERIC,
        title: t`nPoint Count`,
        sortable: true,
        mapping: AGENT_COUNT_FIELD,
        width: 135,
    },
];

export const MATCHING_DEVICES_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Type`,
        sortable: true,
        resizable: false,
        mapping: DEVICE_TYPE_FIELD,
        width: 225,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`Name`,
        sortable: true,
        resizable: false,
        mapping: NAME_FIELD,
        width: 325,
        sortProperty: NORM_NAME_FIELD,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`IP Address`,
        sortable: true,
        resizable: false,
        mapping: IP_ADDRESS_FIELD,
        sortProperty: NORM_IP_ADDRESS_FIELD,
        width: 200,
    },
    {
        type: COLUMN_TYPES.TEXT,
        title: t`IP Scope`,
        resizable: false,
        sortable: false,
        mapping: RULE_VALUE_DISPLAY_FIELD,
        width: 250,
    },
];

export const NOTIFICATIONS_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        resizable: false,
        title: t`Email`,
        sortable: true,
        mapping: NOTIFICATIONS_EMAIL_FIELD,
        flex: 1,
    },
];

export const MATCHING_DEVICE_DATA_SOURCE = {
    url: '/ipm/v1/admin/sites/matchedDevices',
    totalProperty: 'totalDevices',
    dataProperty: 'devices',
    params: {
        searchFields: [NAME_FIELD, DEVICE_TYPE_FIELD, IP_ADDRESS_FIELD],
    },
};

export const MATCHING_AGENTS_DATA_SOURCE = {
    url: '/ipm/v1/admin/sites/matchedAgents',
    totalProperty: 'totalAgents',
    dataProperty: 'agents',
    params: {
        searchFields: [
            NAME_FIELD,
            AGENT_MODEL_SHORT_DISPLAY_FIELD,
            AGENT_TAGS_DISPLAY_FIELD,
            AGENT_DESCRIPTION_FIELD,
            AGENT_STATUS_FIELD,
            AGENT_NETWORK_MAC_FIELD,
            AGENT_SERIAL_NUMBER,
            AGENT_NETWORK_IPV4_LOCAL_FIELD,
            AGENT_NETWORK_IPV4_EXTERNAL_FIELD,
        ],
    },
    initialSort: [{ property: AGENT_NAME_FIELD, direction: SORT_ASC }],
};

export function notificationsEmailDataSource(_id) {
    return {
        url: `/ngp/v2/inventory/subscribers/sites/${_id}`,
        totalProperty: 'count',
        dataProperty: 'data',
        params: {
            searchFields: [NOTIFICATIONS_EMAIL_FIELD],
        },
    };
}
